import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import HomePage from './pages/HomePage';
import Header from './Header';
import { NuPlayerProvider } from '../refactor/nu-player/NuPlayerContext';
import NuPlayer from '../refactor/nu-player/components/NuPlayer';
import ContentPage from './pages/ContentPage';
import { NuStreamerProvider } from '../refactor/nu-streamer/NuStreamerContext';
import CustomPage from './pages/CustomPage';
import getBroadcastData from '../utils/getBroadcastData';
import AccountsModal from './modules/account/AccountsModal';
import NuMediaListener from '../refactor/nu-media/NuMediaListener';
import { useNuStationData } from '../hooks/useNuStationData';
import MessageModal from './MessageModal';

const App = () => {
    const { saveRecentVideo, saveRecentMusic } = useNuStationData();

    const renderPageRoute = () => {
        return <Switch>
            <Route path={['/content/:contentType/:id?']} component={ContentPage}/>
            <Route path={['/list/:contentType/:id?']} component={ContentPage}/>
            <Route path={['/series/:id?']} component={ContentPage}/>
            <Route path={['/shop/:id?']} component={ContentPage}/>
            <Route path={['/page/:slug']} component={CustomPage}/>
        </Switch>;
    };

    const onStreamerProgress = (videoProgress, videoInfo) => {
        const videoId = videoInfo?.videoId;
        const videoDuration = videoInfo?.duration || 0;
        const progressToSave = videoDuration && (videoDuration - videoProgress) < 21 ? 0 : videoProgress;
        if (videoId) {
            saveRecentVideo(videoId, Math.floor(progressToSave), videoProgress % 30 === 0);
        }
    };

    const onMusicPlayerProgress = (musicId, trackIndex) => {
        saveRecentMusic(musicId, trackIndex, true);
    };

    return <AppContainer>
        <NuPlayerProvider onLoadBroadcast={getBroadcastData} onMusicProgress={onMusicPlayerProgress}>
            <NuStreamerProvider onStreamProgress={onStreamerProgress}>
                <Header />
                <HomePage />
                { renderPageRoute() }
                <NuMediaListener />
                <NuPlayer />
            </NuStreamerProvider>
        </NuPlayerProvider>
        <AccountsModal />
        <MessageModal />
    </AppContainer>;
};

export default App;
